import styled from '@emotion/styled'

import { colors } from '@/styles/theme'
import { mediaUp } from '@/styles/media'

export const Wrapper = styled.div`
  background: ${colors.darkSkyBlue};
  margin: 60px 0;
  padding: 40px 0;

  ${mediaUp('lg')} {
    margin: 120px 0;
    padding: 80px 0;
  }
`
